export default function FlattenerCTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-teal-900 to-cyan-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE2YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00em0wIDI0YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00ek0xMiAxNmMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHptMCAyNGMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-30"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            准备好开始使用PDF Forms Flattener了吗？
          </h2>
          
          <p className="text-xl text-gray-300 mb-12 leading-relaxed">
            立即下载免费试用版，体验专业的PDF表单扁平化功能。我们的技术团队随时为您提供支持。
          </p>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-download-cloud-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">1. 下载试用</h3>
              <p className="text-gray-300">填写表单获取免费试用版本</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-settings-3-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">2. 快速安装</h3>
              <p className="text-gray-300">简单的安装流程，几分钟即可完成</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">3. 开始使用</h3>
              <p className="text-gray-300">立即开始处理您的PDF表单</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/contact" 
              className="inline-flex items-center justify-center bg-teal-500 hover:bg-teal-600 text-white px-10 py-4 rounded-lg font-semibold text-lg transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line text-xl mr-2"></i>
              免费下载试用
            </a>
            <a 
              href="/contact" 
              className="inline-flex items-center justify-center bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white px-10 py-4 rounded-lg font-semibold text-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-customer-service-2-line text-xl mr-2"></i>
              咨询技术支持
            </a>
          </div>

          <div className="mt-12 pt-8 border-t border-white/20">
            <p className="text-gray-300 mb-4">需要帮助？查看我们的资源</p>
            <div className="flex flex-wrap justify-center gap-6">
              <a href="/help" className="text-teal-300 hover:text-teal-200 transition-colors cursor-pointer">
                <i className="ri-book-open-line mr-1"></i>
                产品文档
              </a>
              <a href="/resources" className="text-teal-300 hover:text-teal-200 transition-colors cursor-pointer">
                <i className="ri-video-line mr-1"></i>
                视频教程
              </a>
              <a href="/contact" className="text-teal-300 hover:text-teal-200 transition-colors cursor-pointer">
                <i className="ri-question-line mr-1"></i>
                常见问题
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
